module.exports = __webpack_public_path__ + "img/D - 01.3fcbd93d.png";